import {CustomFieldTO} from 'generated/JavaTO'
import _ from 'lodash'

export function cfAttrValueDstFieldsToCFDefs(cfDefs: CustomFieldTO[], value: string, options?: { sorted?: boolean }) {
	const dstFields = _.uniq(value?.split(' ').map(x => x.trim()).filter(x => x))
	const retCFDefs = _.uniq(cfDefs.filter(x => dstFields.includes(x.dstField)))
	if (options?.sorted) retCFDefs.sort((a, b) => dstFields.indexOf(a.dstField) - dstFields.indexOf(b.dstField))
	return retCFDefs
}